const searchCategories = [
  {
    value: "leisure",
    name: "Leisure",
    categories: [
      "leisure",
      "building.spa",
      "entertainment",
      "national_park",
      "beach.beach_resort",
    ],
  },
  {
    value: "library",
    name: "Library",
    categories: [
      "education.library",
    ],
  },
  {
    value: "museums",
    name: "Museums",
    categories: [
      "entertainment.museum",
    ],
  },
  {
    value: "hotels",
    name: "Hotels",
    categories: [
      "accommodation",
    ],
  },
  {
    value: "transport",
    name: "Transport",
    categories: [
      "commercial.gas",
      "public_transport",
      "building.transportation",
    ],
  },
  {
    value: "restaurants",
    name: "Restaurants",
    categories: [
      "catering",
    ],
  },
  {
    value: "pubs",
    name: "Pubs",
    categories: [
      "catering.pub",
    ],
  },
  {
    value: "retail",
    name: "Retail",
    categories:
      [
        "commercial.supermarket",
        "commercial.shopping_mall",
        "tourism.information"
      ]
  },

];

export default searchCategories
